import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'

import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

import * as ValidatorModule from 'validatorjs';

import en from 'validatorjs/src/lang/en';

const Validator = ValidatorModule.default || ValidatorModule;

Validator.setMessages('en', en);


// window.addEventListener('alpine:init', () => {
//   Alpine.onError((error, component, element) => {
//     console.error("🔴 Alpine Error:", error.message, error, element);
//   });
// });




// Optional: initialize Swiper if needed globally
window.addEventListener('DOMContentLoaded', () => {
  var logo_inline_swiper = new Swiper(".logo-swiper", {
    freeMode: true,
    spaceBetween: 0,
    grabCursor: true,
    slidesPerView: 4,
    loop: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 7,
      },
    },
    freeMode: true,
    speed: 5000,
    freeModeMomentum: false
  });

  var team_slider = new Swiper(".team-swiper", {

    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 0,
        centeredSlides: false,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: false,
      },
    },
    navigation: {
        nextEl: ".gb-swiper-button-next",
        prevEl: ".gb-swiper-button-prev",
      },
  });

  var how_slider = new Swiper(".how-swiper", {
    spaceBetween: 0,
    grabCursor: true,
    slidesPerView: 1.3,
    spaceBetween: 15,
    loop: false,
    centeredSlides: true,
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
    },
    navigation: {
        nextEl: ".gb-swiper-button-next",
        prevEl: ".gb-swiper-button-prev",
      },
  });

  var article_slider = new Swiper(".article-swiper", {
    autoHeight: false,
    spaceBetween: 0,
    grabCursor: true,
    slidesPerView: 1.1,
    spaceBetween: 30,
    loop: false,
    centeredSlides: true,
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
    },
    navigation: {
        nextEl: ".gb-swiper-button-next",
        prevEl: ".gb-swiper-button-prev",
      },
  });


});


document.addEventListener('alpine:init', () => {

  if (typeof wp !== 'undefined' && wp.data) {
        // Running inside editor → skip Alpine or disable
        return;
    }

  Alpine.data('equalHeightComponent', () => ({
    includeMargins: false, // set true if you want to include margins in the measurement

    init() {
      // run after everything (fonts/images) has loaded
      const run = () => {
        this.equalize('boxes');
        this.equalize('boxes-alt');
      };
      if (document.readyState === 'complete') {
        requestAnimationFrame(() => requestAnimationFrame(run));
      } else {
        window.addEventListener('load', () => {
          requestAnimationFrame(() => requestAnimationFrame(run));
        }, { once: true });
      }

      // keep equalized on resize
      const ro = new ResizeObserver(() => this.equalize('boxes') || this.equalize('boxes-alt'));
      ro.observe(this.$el);
      this._ro = ro;
    },

    // compute outer height (optionally incl. margins)
    _outerHeight(el) {
      const rect = el.getBoundingClientRect(); // padding + border (no margins)
      if (!this.includeMargins) return rect.height;

      const cs = getComputedStyle(el);
      const mt = parseFloat(cs.marginTop) || 0;
      const mb = parseFloat(cs.marginBottom) || 0;
      return rect.height + mt + mb;
    },

    equalize(ref) {
      const boxes = Array.from(this.$el.querySelectorAll(`[x-ref="${ref}"]`));
      if (!boxes.length) return;

      // strongly recommended in CSS for consistent results:
      // [x-ref="boxes"], [x-ref="boxes-alt"] { box-sizing: border-box; }

      // reset before measuring
      boxes.forEach(el => {
        el.style.minHeight = ''; // safer than height
        el.style.height = '';    // clear any previous explicit height
      });

      // ensure layout has flushed
      // (we already used rAF in init, but this keeps it robust when called later)
      const heights = boxes.map(el => this._outerHeight(el));
      const max = Math.max(...heights);

      // apply as min-height (content+padding+border). Margins can’t be set via height.
      boxes.forEach(el => { el.style.minHeight = `${max}px`; });
    }
  }));


  
});

Alpine.data('logoScroller', () => ({
  pos: 0,
  speed: 0.5, // adjust scroll speed
  track: null,
  trackWidth: 0,
  start() {
    this.track = this.$refs.track
    this.trackWidth = this.track.scrollWidth / 2 // width of one full set

    const step = () => {
      this.pos -= this.speed

      // when we've shifted one full set, reset by that width
      if (Math.abs(this.pos) >= this.trackWidth) {
        this.pos += this.trackWidth
      }

      requestAnimationFrame(step)
    }
    requestAnimationFrame(step)
  }
}));

window.oneOffDonationForm = (data) => {

  return {
    formData: {
      once_amount: data.once_amount,
      monthly_amount: data.monthly_amount,
    },
    selected: data.selected,
    once_amount: data.once_amount,
    monthly_amount: data.monthly_amount,
    once_url: data.once_url_base,
    regular_url: data.regular_url_base,

    updateOnceUrl() {
      // this.once_url: '{{ once_url }}'+'?amount='+formData.once_amount;
    },

    updateRegularUrl() {
      // this.regular_url: '{{ regular_url }}'+'?amount='+formData.monthly_amount;
    },

    giveMonthly() {
      window.location.href = this.regular_url+'?recurring=1&amount='+this.formData.monthly_amount;
    },

    giveOnce() {
      window.location.href = this.once_url+'?amount='+this.formData.once_amount;
    },

  }
}


window.elInView = el => {
  const rect = el.getBoundingClientRect()
  return (
    rect.top < window.innerHeight &&
    rect.bottom > 0
  )
}

Alpine.data('shareComponent', (data) => ({
    copied: false,
    copyUrl(passedURL) {
      let url;
      if(passedURL){
        // console.log(passedURL);
        url = passedURL;
      } else {
        url = window.location.href;
        // console.log(url);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url)
          .then(() => this.showCopied())
          .catch(() => this.fallbackCopy(url));
      } else {
        this.fallbackCopy(url);
      }
    },
    fallbackCopy(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.showCopied();
      } catch (err) {
        alert('Copy failed. Please copy manually.');
      }
      document.body.removeChild(input);
    },
    showCopied() {
      this.copied = true;
      setTimeout(() => this.copied = false, 2000);
    }
}));

Alpine.plugin(intersect)
Alpine.plugin(collapse)
window.Alpine = Alpine
Alpine.start()